<template>
  <div class="min-h-full sticky top-0 z-50" v-if="getnavbar">
    <div
      as="nav"
      class="border-b border-gray-200 dark:border-dtheme-700 bg-white dark:bg-dtheme-900"
    >
      <div class="mx-auto px-3 sm:px-6 lg:px-3">
        <div class="flex h-16 justify-between">
          <div class="flex justify-center items-center">
            <!-- <div class="app-logo-dark w-40 mr-20">
              <img src="@/assets/definedge-dark-logo.png" />
            </div> -->

            <div class="app-logo-dark w-40 mr-20">
              <img src="@/assets/definedge-dark-logo.png" />
            </div>
            <div class="app-logo-light w-40 mr-20">
              <img src="@/assets/definedge-light-logo.png" />
            </div>
            <button
              type="button"
              class="-m-2.5 p-2.5 text-gray-700"
              @click="toggleSideBar()"
            >
              <Bars3Icon class="h-6 w-6 dark:text-white" aria-hidden="true" />
            </button>
            <div
              class="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8 dark:text-white"
            >
              <h1>Definedge Securities Dashboard</h1>
            </div>
          </div>
          <div class="hidden sm:ml-6 sm:flex sm:items-center">
            <button
              type="button"
              class="text-gray-400 mr-4"
              @click="toggleDark()"
            >
              <!-- <MoonIcon
                class="h-6 w-6 text-gray-500 dark:text-black-200"
                aria-hidden="true"
              /> -->
              <div class="moon-icon">
                <img src="@/assets/moon-dark.svg" />
              </div>
              <div class="sun-icon">
                <img src="@/assets/sun-light.svg" class="text-slate-500" />
              </div>
            </button>
            <!-- Profile dropdown -->
            <Menu as="div" class="relative inline-block text-left">
              <div>
                <MenuButton
                  class="inline-flex justify-center items-center gap-x-1.5 rounded-full bg-white p-2 h-11 w-11 text-sm font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:text-white dark:bg-dtheme-700 dark:ring-black-300"
                >
                  {{ initials }}
                </MenuButton>
              </div>

              <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <MenuItems
                  class="absolute right-0 z-10 mt-2.5 origin-top-right divide-y divide-gray-100 dark:divide-black-300 rounded-md shadow-xl px-4 py-2 border border-gray-200 dark:border-black-300 bg-white dark:bg-dtheme-700"
                >
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ firstname }}
                  </div>
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ email }}
                  </div>
                  <div
                    class="py-2 flex items-center justify-start text-sm cursor-pointer"
                  >
                    <MenuItem v-slot="{ active }">
                      <a
                        @click="onLogout()"
                        :class="[
                          active ? ' text-gray-500' : 'text-gray-700',
                          'group flex items-center text-sm text-gray-400 dark:text-white',
                        ]"
                      >
                        <ArrowRightOnRectangleIcon
                          class="mr-3 h-5 w-5"
                          aria-hidden="true"
                        />
                        Sign Out
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
            <div class="ml-4 dark:text-white">{{ ucc }}</div>
          </div>
          <div class="flex items-center sm:hidden">
            <!-- Mobile menu button -->
            <Menu as="div" class="relative inline-block text-left">
              <div>
                <MenuButton
                  class="inline-flex w-full justify-center gap-x-1.5 rounded-full bg-white px-2 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                  {{ initials }}
                </MenuButton>
              </div>

              <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <MenuItems
                  class="absolute right-0 z-10 mt-2.5 origin-top-right divide-y divide-gray-100 dark:divide-black-300 rounded-md shadow-xl px-4 py-2 border border-gray-200 dark:border-black-300 bg-white dark:bg-dtheme-700"
                >
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ firstname }}
                  </div>
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ email }}
                  </div>
                  <div
                    class="py-2 flex items-center justify-start text-sm cursor-pointer"
                  >
                    <MenuItem v-slot="{ active }">
                      <a
                        @click="onLogout()"
                        :class="[
                          active ? ' text-gray-500' : 'text-gray-700',
                          'group flex items-center text-sm text-gray-400 dark:text-white',
                        ]"
                      >
                        <ArrowRightOnRectangleIcon
                          class="mr-3 h-5 w-5"
                          aria-hidden="true"
                        />
                        Sign Out
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, defineComponent, computed, onMounted } from "vue";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
// import { MoonIcon } from "@heroicons/vue/24/outline";
import { useUserStore } from "../store/user";
import { ArrowRightOnRectangleIcon, Bars3Icon } from "@heroicons/vue/20/solid";
import { useCommonStore } from "@/store/commonStore";
import { useDark, useToggle } from "@vueuse/core";
export default defineComponent({
  components: {
    // MoonIcon,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ArrowRightOnRectangleIcon,
    Bars3Icon,
  },
  setup() {
    const isDark = useDark();
    const toggleDark = useToggle(isDark);
    const userStore = useUserStore();
    const commonStore = useCommonStore();
    const state = reactive({
      getnavbar: computed(() => commonStore.getNavbar),
      email: computed(() => userStore.username.email),
      ucc: computed(() => userStore.username.ucc),
      firstname: computed(
        () => userStore.username.firstname + " " + userStore.username.lastname
      ),
      initials: computed(() => {
        console.log("user is : ", userStore?.username);
        const fullnameArray = userStore?.username.firstname?.split("");
        console.log("initial letter : ", fullnameArray?.[0]?.split("")?.[0]);
        const firstchar = fullnameArray?.[0]?.split("")?.[0];
        const secondchar = fullnameArray?.[1]?.split("")?.[0];
        const finalchar = firstchar + secondchar;
        console.log("initial letter final : ", finalchar);
        return finalchar;
      }),
    });
    const toggleSideBar = () => {
      commonStore.sidebarOpen = !commonStore.sidebarOpen;
    };
    const onLogout = () => {
      window.location.assign("/logout");
    };
    onMounted(() => {
      // console.log("isDark", isDark.value);
    });
    return { ...toRefs(state), onLogout, toggleSideBar, toggleDark };
  },
});
</script>
